<template>
 <v-hover>
  <v-card slot-scope="{ hover }"
      :class="`elevation-${hover ? 12 : 2}`">
    <v-img :src="mapsUrl" height="200px" @click="showMap = true">
      <gmap-map
        :center="{lat:item.pos.y, lng:item.pos.x}"
        v-if="showMap"
        :zoom="7"
        :options="{'gestureHandling':'greedy'}"
        map-type-id="terrain"
        style="width: 100%; height: 200px"
      >
        <gmap-marker :position="marker.position" :clickable="true"></gmap-marker>
      </gmap-map>
    </v-img>

    <v-card-title primary-title>
      <div>
        <h3 class="headline mb-0">{{item.fullDescription}}</h3>
        <slot name="subheader"></slot>
		<unit-control
		v-if="item.sensors"
		:sensors="item.sensors"
		class="mt-1"
		></unit-control>
      </div>
    </v-card-title>
    <v-card-actions>
      <slot></slot>
    </v-card-actions>
  </v-card>
 </v-hover>
</template>

<script>
import * as utils from "@/utils/utils";
import UnitControl from '@/components/Units/UnitControl';
export default {
  name: "UnitTrackCard",
  components: { UnitControl },
  props: ["item"],
  data() {
    return {
      showMap: false
    };
  },
  computed: {
    mapsUrl() {
      var self = this;
      var pos = self.item.pos.y + "," + self.item.pos.x;
      var color = self.item.color ? self.item.color.toLowerCase() : "red";
      var key = "AIzaSyCgaCVWpKectL7lCRTC7oriHlBx7I_bV3w";
      var url =
        "//maps.googleapis.com/maps/api/staticmap?center=" +
        pos +
        "&zoom=8&size=400x400&markers=color:" +
        color +
        "%7C" +
        pos +
        "&key=" +
        key;
      return url;
    },
    marker() {
      return {
        position: {
          lat: this.item.pos.y,
          lng: this.item.pos.x
        }
      };
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/TestDrives/UnitTrackCard.vue